/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_French14Inputs */

const en__field__enum_teachingsubjects_subject_french14 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_French14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`French`)
};

const de__field__enum_teachingsubjects_subject_french14 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_French14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Französisch`)
};

/**
* | output |
* | --- |
* | "French" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_French14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_french14 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_French14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_French14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_french14(inputs)
	return de__field__enum_teachingsubjects_subject_french14(inputs)
});
export { _field__enum_teachingsubjects_subject_french14 as "_field__enum_teachingSubjects_SUBJECT_FRENCH" }